"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.carbon = void 0;
const carbon = exports.carbon = {
  CARBON_FORESIGHT: {
    en: {
      title: 'Carbon Foresight',
      subtitle: 'The key to unlocking a sustainable future',
      description: 'Empower your decision making with industry-leading carbon forecasts for true market balance, taking into account power generation figures and hedging behaviours of different players to give a more accurate understanding of underlying market drivers.'
    },
    zh: {
      title: '碳预测与分析',
      subtitle: '解锁可持续未来之钥',
      description: '业内领先的碳预测反映了真实的市场情况，囊括发电数据和不同市场参与者的套保操作，以便您更加准确地把握市场潜在驱动因素，助力决策制定。'
    }
  }
};